import React, { useMemo } from "react"
import useDebounceQueryParams from "magik-react-hooks/useRouterDebounceQueryParams"
import useModalTrigger from "magik-react-hooks/useModalTrigger"
import { useRunRj } from "react-rocketjump"
import { PrestazioneState } from "../../state/prestazioni"
import Layout from "../../components/Layout/Layout"
import ModalDelete from "../../components/Modals/ModalDelete"
import ListPrestazioni from "../../components/Prestazioni/ListPrestazioni"
import ModalFormPrestazione from "../../components/Prestazioni/ModalFormPrestazione"
import { AddCircle, Cancel, GetApp, RotateLeft } from "@material-ui/icons"
import qs from "query-string"
import {
  TextField,
  Button,
  Card,
  CircularProgress,
  Grid,
  InputAdornment,
  IconButton,
} from "@material-ui/core"
import { useExportToken } from "../../state/exportToken"
import { useSelectedAzienda } from "../../SelectedAzienda"
import { isMobile } from "react-device-detect"

export default function Prestazioni() {
  const [{ selectedAzienda }] = useSelectedAzienda()
  const [
    queryParams,
    setQueryParams,
    debQueryParams,
    setDebQueryParams,
  ] = useDebounceQueryParams()

  const [modalCreate, actionsModalCreate] = useModalTrigger()
  const [modalUpdate, actionsModalUpdate] = useModalTrigger()
  const [modalDelete, actionsModalDelete] = useModalTrigger()
  const { value: deleteServizio } = modalDelete

  const onUpdate = (servizio) => actionsModalUpdate.open(servizio)
  const onDelete = (servizio) => actionsModalDelete.open(servizio)

  const filters = useMemo(() => {
    return { ...debQueryParams, azienda: selectedAzienda.id }
  }, [debQueryParams, selectedAzienda])

  const [
    { list, loading, pagination },
    { addServizio, updateServizio, removeServizio },
  ] = useRunRj(PrestazioneState, [filters], false)

  const columnProps = {
    value: queryParams.ordering,
    onChange: (value) => setDebQueryParams({ ordering: value }),
  }

  const isProductionEnv = process.env.NODE_ENV === "production"
  const host = isProductionEnv ? window.location.host : "localhost:8000"
  const protocol = window.location.protocol

  const exportToken = useExportToken()

  const linkCsv = useMemo(() => {
    return `${protocol}//${host}/api/prestazioni-export/csv?${qs.stringify({
      ...filters,
      export_token: exportToken,
    })}`
  }, [exportToken, filters, host, protocol])

  const linkPdf = useMemo(() => {
    return `${protocol}//${host}/api/prestazioni-export/pdf?${qs.stringify({
      ...filters,
      export_token: exportToken,
    })}`
  }, [exportToken, filters, host, protocol])

  return (
    <Layout title="Servizi">
      <div>
        <Card className="card-filters">
          <Grid container>
            <Grid item xs={12} md={6}>
              <div>
                <TextField
                  size="small"
                  placeholder="Cerca..."
                  value={queryParams.search ?? ""}
                  onChange={(e) =>
                    setDebQueryParams({
                      search: e.target.value,
                      page: 1,
                    })
                  }
                  style={{ width: isMobile ? '100%' : undefined}}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          disabled={!queryParams.search}
                          aria-label="toggle password visibility"
                          onClick={() => setQueryParams(() => {})}
                          edge="end"
                        >
                          <Cancel
                            color={!queryParams.search ? undefined : "primary"}
                          />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  id="outlined-basic"
                  variant="outlined"
                />
              </div>
            </Grid>
            <Grid item md={6} xs={12}>
              <div
                className={
                  isMobile ? "d-flex justify-content-center pt-5" : "text-right"
                }
              >
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<GetApp />}
                  href={linkCsv}
                >
                  Excel
                </Button>
                <Button
                  style={{ marginLeft: 10 }}
                  variant="contained"
                  color="primary"
                  target="_blank"
                  startIcon={<GetApp />}
                  href={linkPdf}
                >
                  Pdf
                </Button>
              </div>
            </Grid>
          </Grid>
        </Card>
        <Card className="card-add">
          <Button
            variant="contained"
            color="primary"
            startIcon={<AddCircle />}
            onClick={() => actionsModalCreate.open()}
          >
            Aggiungi servizio
          </Button>
        </Card>
        {list === null && loading && (
          <div style={{ textAlign: "center" }}>
            <CircularProgress color="primary" />
          </div>
        )}
        {list && (
          <ListPrestazioni
            columnProps={columnProps}
            pagination={pagination}
            servizi={list}
            onUpdate={onUpdate}
            onDelete={onDelete}
          />
        )}
        <ModalFormPrestazione
          save={(servizio) => {
            return addServizio
              .onSuccess(() => actionsModalCreate.close())
              .asPromise({ ...servizio, azienda: selectedAzienda.id })
          }}
          isOpen={modalCreate.isOpen}
          toggle={actionsModalCreate.toggle}
          onExited={actionsModalCreate.onClosed}
        />
        <ModalFormPrestazione
          save={(servizio) => {
            return updateServizio
              .onSuccess(() => actionsModalUpdate.close())
              .asPromise({ ...servizio, azienda: selectedAzienda.id })
          }}
          servizio={modalUpdate.value}
          isOpen={modalUpdate.isOpen}
          toggle={actionsModalUpdate.toggle}
          onExited={() => {
            actionsModalUpdate.onClosed()
          }}
        />
        <ModalDelete
          isOpen={modalDelete.isOpen}
          toggle={actionsModalDelete.toggle}
          title={deleteServizio ? `Rimuovere ${deleteServizio.titolo}?` : null}
          text={
            deleteServizio
              ? `Sei sicuro di voler eliminare il servizio ${deleteServizio.titolo}?`
              : null
          }
          onDelete={() => {
            return removeServizio
              .onSuccess(() => actionsModalDelete.close())
              .asPromise(modalDelete.value)
          }}
          onExited={() => {
            actionsModalDelete.onClosed()
          }}
        />
      </div>
    </Layout>
  )
}
